import * as STD                          from '@emersya/mpa-std-lib';
import * as BasketNS                     from '@emersya/mpa-basket-lib';
import CM                                from '@emersya/mpa-components-manager-lib';

export interface IOMSBasketComponentConfiguration extends CM.Component.IConfiguration,
	Omit<BasketNS.IBasketDescriptor, 'application'>
{
	readonly application : MPAEngineApplicationComponent<any, any>;
};

export class OMSBasketComponent extends CM.Component<
	OMSBasketComponent,
	IOMSBasketComponentConfiguration
>
{
	static count = 0;

	static override initialize() {
		CM.Component.initialize.call(this);
		this.eventsTypes.push(...BasketNS.Basket.eventsTypes);
	};

	application : MPAEngineApplicationComponent<any, any>;
	basket : BasketNS.Basket;

	override component_hasValue() {
		return (true);
	};

	override async component_initialize() {
		await this.basket.initialize();
		await super.component_initialize();
	};

	private async onEventToPropagate(event : STD.events.Event<BasketNS.Basket, any>) {
		if (app.isReloading && !app.currentProduct && event.subType !== 'productUsed') {
			return;
		}
		await event.propagate<OMSBasketComponent, CM.Component<any, any>>(this, {
			bubbles :    false,
			composed :   false,
			cancelable : false
		});
	};

	async reloadFromSerialized(serialized : ReturnType<typeof BasketNS.Basket.prototype.serialize>) {
		const [ bc, dc ] = [ serialized.billingContact, serialized.deliveryContact ];
		const assignSerialiazedContactContent = (
			contact : BasketNS.Contact,
			serialized : any
		) => {
			for (const [ k, v ] of Object.entries(serialized)) {
				contact.set(k, v);
			}
		};
		if (bc || dc) {
			if (bc && dc) {
				if (STD.object.hasSameContentDeeply(bc, dc)) {
					const contact = new BasketNS.Contact();
					this.basket.billingContact = contact;
					this.basket.deliveryContact = contact;
					assignSerialiazedContactContent(contact, bc);
				} else {
					this.basket.billingContact = new BasketNS.Contact();
					this.basket.deliveryContact = new BasketNS.Contact();
					assignSerialiazedContactContent(this.basket.billingContact, dc);
					assignSerialiazedContactContent(this.basket.deliveryContact, bc);
				}
			} else {
				if (bc) {
					this.basket.deliveryContact = null;
					this.basket.billingContact = new BasketNS.Contact();
					assignSerialiazedContactContent(this.basket.billingContact, dc);
				} else {
					this.basket.billingContact = null;
					this.basket.deliveryContact = new BasketNS.Contact();
					assignSerialiazedContactContent(this.basket.deliveryContact, bc);
				}
			}
		}
		await <any> void 1;
	};

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IOMSBasketComponentConfiguration
	)
	{
		super(descriptor, configuration);
		if (OMSBasketComponent.count !== 0) {
			throw STD.errors.user('Only one application component is allowed!');
		}
		const appComponent = this.component_getRoot();
		if (!(appComponent instanceof MPAEngineApplicationComponent)) {
			throw STD.errors.user(
				'Root component must be an instance of an application component!',
				{ root : appComponent }
			);
		}
		this.application = appComponent;
		this.basket = new BasketNS.Basket(Object.assign({}, configuration, {}));
		OMSBasketComponent.count++;
		this.basket.addEventListener('basket-update', this.onEventToPropagate.bind(this), {
			listener : this,
			subType :  '*'
		});
		this.basket.addEventListener('price-update', this.onEventToPropagate.bind(this), {
			listener : this,
			subType :  '*'
		});
	};
};
export namespace NS {
	export const Component = OMSBasketComponent;
	export type Component = OMSBasketComponent;
	export type Configuration = IOMSBasketComponentConfiguration;
}
import { MPAEngineApplicationComponent } from '../../mpa-engine/Application/MPAEngineApplication';

CM.declare({
	id :   'oms-basket',
	type : OMSBasketComponent
});
